/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";

import TableRow from "@material-ui/core/TableRow";
import CarrierManagementRow from "./CarrierManagementRow";
import { useTheme } from "@material-ui/core/styles";
import { fetchCarriers } from "../../slices/carrierManagementSlice";
import RightDrawer from "../../containers/RightDrawer";
import CarrierManagementDetails from "./CarrierManagementDetails";
import Notification from "../common/Notification";
import StyledNoResults from "../common/StyledNoResults";
import StyledOverlay from "../common/StyledOverlay";
import { fetchOrganizations } from "../../slices/organizationsSlice";

const StyledTableContainer = styled(TableContainer)`
  flex: 1 0 auto;
  height: 0px;
`;

const StyledTableRow = styled(TableRow)`
  .sticky {
    position: sticky !important;
    top: 0;
    z-index: 90;
  }
`;

const CarrierManagementTable = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const carriers = useSelector(
    (state) => state.carrierManagementCarriers.carriers
  );
  const isFetching = useSelector(
    (state) => state.carrierManagementCarriers.isFetching
  );
  const [openedRow, setOpenedRow] = useState(null);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [unsavedModalOpen, setUnsavedModalOpen] = useState(false);
  const [carrierInfoUnsavedChanges, setCarrierInfoUnsavedChanges] = useState(
    false
  );
  const [carrierOrgUnsavedChanges, setCarrierOrgUnsavedChanges] = useState(
    false
  );

  useEffect(() => {
    dispatch(fetchCarriers());
    dispatch(fetchOrganizations());
  }, []);

  const handleNotification = (message) => {
    setShowSuccessNotification(true);
    setSuccessMessage(message);
  };

  const handleUnsavedChanges = (type, value) => {
    if (!type) {
      setCarrierInfoUnsavedChanges(false);
      setCarrierOrgUnsavedChanges(false);
    } else if (type === "carrierForm") {
      setCarrierInfoUnsavedChanges(value);
    } else if (type === "carrierOrg") {
      setCarrierOrgUnsavedChanges(value);
    }
  };

  return (
    <>
      {isFetching && <StyledOverlay theme={theme} />}
      {carriers.length > 0 ? (
        <>
          {openedRow && (
            <RightDrawer width={550}>
              <CarrierManagementDetails
                openedRow={openedRow}
                setOpenedRow={setOpenedRow}
                setSuccessMessage={handleNotification}
                setUnsavedChanges={handleUnsavedChanges}
                carrierInfoUnsavedChanges={carrierInfoUnsavedChanges}
                carrierOrgUnsavedChanges={carrierOrgUnsavedChanges}
                setUnsavedModalOpen={setUnsavedModalOpen}
                unsavedModalOpen={unsavedModalOpen}
              />
            </RightDrawer>
          )}
          <StyledTableContainer>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <TableCell theme={theme} align="left" key="tier">
                    Tier
                  </TableCell>
                  <TableCell theme={theme} align="left" key="carrierName">
                    Carrier Name
                  </TableCell>
                  <TableCell theme={theme} align="left" key="contact">
                    Contact
                  </TableCell>
                  <TableCell theme={theme} align="left" key="email">
                    Email
                  </TableCell>
                  <TableCell theme={theme} align="left" key="phoneNumber1">
                    Phone #
                  </TableCell>
                  <TableCell theme={theme} align="left" key="phoneNumber2">
                    Phone #
                  </TableCell>
                  <TableCell theme={theme} align="left" key="phoneNumber3">
                    Phone #
                  </TableCell>
                  <TableCell
                    theme={theme}
                    align="left"
                    key="associatedUserCount"
                  >
                    Associated Users
                  </TableCell>
                  <TableCell theme={theme} align="left" key="organizationName">
                    Organization
                  </TableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {carriers.map((row) => {
                  return (
                    <CarrierManagementRow
                      carrierId={row.carrierId}
                      key={row.carrierId}
                      setOpenedRow={setOpenedRow}
                      row={row}
                    />
                  );
                })}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </>
      ) : (
        <StyledNoResults theme={theme}>
          {!isFetching && "No Results"}
        </StyledNoResults>
      )}
      <Notification
        message={successMessage}
        open={showSuccessNotification}
        setOpen={setShowSuccessNotification}
      />
    </>
  );
};

export default CarrierManagementTable;
